import React, { useState, createContext, useMemo } from 'react';

import { SelectReport } from './SelectReport';
import { ReportParams } from './ReportParams';
import { DisplayReport } from './DisplayReport';

export const ReportingContext = createContext();

export default function ReportingContainer() {
  const [reportId, setReportId] = useState(null);
  const [reportingPage, setReportingPage] = useState(null);
  const [reportName, setReportName] = useState(null);
  const [endpoint, setEndpoint] = useState(null);
  const [endpointParams, setEndpointParams] = useState({});
  const navToReportingPage = (page) => {
    setReportingPage(page);
  };

  const reportingContextValue = useMemo(
    () => ({
      setReportId,
      reportId,
      navToReportingPage,
      reportName,
      setReportName,
      endpoint,
      setEndpoint,
      endpointParams,
      setEndpointParams,
    }),
    [
      setReportId,
      reportId,
      navToReportingPage,
      reportName,
      setReportName,
      endpoint,
      setEndpoint,
      endpointParams,
      setEndpointParams,
    ]
  );

  return (
    <ReportingContext.Provider value={reportingContextValue}>
      {reportingPage === null && <SelectReport />}
      {reportingPage === 1 && <ReportParams />}
      {reportingPage === 2 && <DisplayReport />}
    </ReportingContext.Provider>
  );
}
